// Interruptor de estado Pendiente/Aprobado ("LC Switch"). Encendido = aprobado; apagado =
// pendiente (o rechazado, mostrando además un texto "Rechazado" al lado). Al encenderse desde
// rechazado pasa a aprobado.
export const EstadoSwitch = ({ estado, onChange, disabled, onDark, testId, title, soloLectura }) => {
  const checked = estado === "aprobado";
  const rechazado = estado === "rechazado";

  const alternar = () => {
    if (disabled) return;
    onChange(checked ? "pendiente" : "aprobado");
  };
  const onKeyDown = (e) => {
    if (disabled) return;
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); alternar(); }
  };

  return (
    <span className="inline-flex items-center gap-1.5">
      <button type="button" role="switch" aria-checked={checked} data-testid={testId} title={title}
        disabled={disabled} onClick={alternar} onKeyDown={onKeyDown}
        className={`switch-lc ${checked ? "is-on" : ""} ${onDark ? "switch-lc--on-dark" : ""} ${soloLectura ? "switch-lc--solo-lectura" : ""}`}>
        <span className="switch-lc__knob" />
        <span className="switch-lc__label switch-lc__label--on">Aprobado</span>
        <span className="switch-lc__label switch-lc__label--off">Pendiente</span>
      </button>
      {rechazado && (
        <span data-testid={testId ? `${testId}-rechazado` : undefined}
          className="text-[11px] font-medium text-pink-600">Rechazado</span>
      )}
    </span>
  );
};
